import { Directive } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { DateValidatorService } from '../services/date-validator/date-validator.service';

@Directive({
    selector: '[inputDateValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: DateValidatorDirective,
        multi: true
    }]
})
export class DateValidatorDirective implements Validator {
    constructor(private dateValidatorService: DateValidatorService){}

    validate(control: AbstractControl): ValidationErrors {
        return this.dateValidatorService.dateValidator(control as FormGroup);
    }
}
